











import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
/**
 * `Lower Footer` - Lower Footer for OneWeb - Lower Footer contains the social and legal sections of the Footer, this component is able to display via slots the corresponding components.
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-lower-footer',
  components: {
    SlotContainer,
  },
});
